// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3ZTc4","title":"ClientInsurance_title__1Y83J","itemText":"ClientInsurance_itemText__1SW_3"};